
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/plugins/stickyElements/js/stickyElements';
  
const main = (UX) => {


try {
        UX.stickyElements.init();
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        